import styled from 'styled-components'
import { colors } from "../../branding";


export const StyledContactForm = styled.section`
  background-color: ${colors.pale};
  width: 100vw;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 50px;
  
  
  form {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    
    .ContactForm-checkbox-container {
      display: flex;
      flex-direction: row;
      
      .ContactForm-checkbox {
        margin: 0 10px 10px; 
        display: flex;
        align-items: center;
        
        label {
          padding-left: 5px;
          color: ${colors.blueDark};
          font-weight: bold;
        }
      }
    }
    
    .ContactForm-input-container {
      width: 100%;
      max-width: 800px;
      margin: 5px;
      display: flex;
      flex-direction: column;
      
      .ContactForm-input {
        border: 1px solid ${colors.grey};
        border-radius: 5px 0 0 5px;
        display: flex;
        justify-content: space-between;
        overflow: hidden;
        margin: 0 10px;
        
        svg {
          height: 20px;
          width: 20px;
          padding: 15px;
          margin: 0;
          background-color: ${colors.grey};
          color: ${colors.light};
          border-right: 1px solid ${colors.grey};
        }
        
        input,
        select,
        textarea {
          height: 40px;
          padding: 5px 10px;
          font-size: 24px;
          border: none;
          border-radius: 0;
          width: calc(100% - 51px);
          font-family: 'Roboto', sans-serif;
        }

        &.textarea {
          display: flex;
          justify-content: start;

          svg {
            height: auto;
          }

          textarea {
            width: 100%;
            height: 100%;
            max-height: 200px;
            resize: vertical;
            overflow: auto;
          }
        }
        
        select {
          height: 50px;
          color: ${colors.black};
        }
      }
      
      .ContactForm-input-message {
        font-size: 12px;
        width: calc(100% - 20px);
        text-align: right;
        display: block;
        height: 20px;
        padding: 5px 0;
        color: ${colors.grey};
        margin: 0 10px;
      }
      
      &.error {
        .ContactForm-input {
          border-color: ${colors.red};
          
          svg {
            border-right-color: ${colors.red};
            background-color: ${colors.red};
          }
        }

        .ContactForm-input-message {
          color: ${colors.red};
        }
      }

      &.success {
        .ContactForm-input {
          border-color: ${colors.green};

          svg {
            border-right-color: ${colors.green};
            background-color: ${colors.green};
          }
        }

        .ContactForm-input-message {
          color: ${colors.green};
        }
      }
    }
    
    button {
      background-image: linear-gradient(to right bottom, ${colors.blueMidLight} 0%, ${colors.blueDark} 100%);
      background-color: ${colors.blueDark};
      color: ${colors.light};
      padding: 10px 20px;
      font-size: inherit;
      font-weight: bold;
      border-radius: 5px;
      min-width: 200px;
      margin: 10px;
      
      :hover {
        transform: scale(1.05);
      }
    }
  }

  @media (max-width: 600px) {  
    form {
      .ContactForm-input-container {
        .ContactForm-input {
          input,
          select,
          textarea {
            font-size: 16px;
          }
        }
      }
    }
  }
  
  @media (max-width: 500px) {
    form {
      .ContactForm-checkbox-container {
        flex-direction: column;
        
      }
    }
  }
   
`
